export const registration = {
  hero: {
    title: 'PRIJAVA',
    subtitle: 'Osigurajte svoje mjesto na vodećoj planinskoj trci Crne Gore',
  },
  pricing: {
    title: 'CIJENE PRIJAVE',
    skyrace: 'SINJAVINA SKYRACE - 40KM',
    miniSkyrace: 'SINJAVINA MINI SKYRACE - 10KM',
    early: {
      title: 'RANA PRIJAVA',
      deadline: 'Do 1. marta 2026',
      badge: 'NAJBOLJA VRIJEDNOST',
    },
    standard: {
      title: 'STANDARDNA PRIJAVA',
      deadline: 'Do 30. aprila 2026',
    },
    late: {
      title: 'KASNA PRIJAVA',
      deadline: 'Do 15. maja 2026',
      badge: 'OGRANIČENA MJESTA',
    },
    buttonSkyrace: 'PRIJAVI SE SADA - SKYRACE',
    buttonMini: 'PRIJAVI SE SADA - MINI SKYRACE',
  },
  dates: {
    title: 'KLJUČNI DATUMI',
    march1: {
      date: '1. MART 2026',
      event: 'Rok za ranu prijavu',
      detail: 'Posljednji dan za snižene cijene',
    },
    april30: {
      date: '30. APRIL 2026',
      event: 'Standardna prijava se zatvara',
      detail: 'Cijene rastu nakon ovog datuma',
    },
    may15: {
      date: '15. MAJ 2026',
      event: 'Konačan rok za prijavu',
      detail: 'Prijave se ne prihvataju nakon ovog datuma',
    },
    june5: {
      date: '5. JUNI 2026',
      event: 'Preuzimanje startnih paketa u Mojkovcu',
      detail: '15:00 - 21:00h (lokacija će biti naknadno određena)',
    },
    june6: {
      date: '6. JUNI 2026',
      event: 'DAN TRKE',
      detail: 'Start: 08:00h - Motel Ravnjak, Bistrica',
    },
  },
  included: {
    title: 'VAŠ STARTNI PAKET UKLJUČUJE',
    bib: {
      title: 'Startni broj',
      description: 'Personalizirani broj za trku',
    },
    shirt: {
      title: 'Tehnička majica',
      description: 'Službena oprema događaja',
    },
    marking: {
      title: 'Označavanje staze',
      description: 'Potpuno označena staza sa mapama',
    },
    aid: {
      title: 'Okrepne stanice',
      description: 'Višestruke tačke za osvježenje',
    },
    medal: {
      title: 'Finišerska medalja',
      description: 'Za sve koji završe u vremenskom limitu',
    },
    meal: {
      title: 'Obrok nakon trke',
      description: 'Topli obrok nakon cilja',
    },
  },
  cta: {
    title: 'SPREMNI STE ZA IZAZOV?',
    button: 'ZAVRŠITE PRIJAVU',
  },
};